module.exports = __webpack_public_path__ + "img/9_78.6f9774e6.png";